import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChooseDefaultAddressDialogComponent } from '@x/ecommerce-shop/app/core/auth/components/choose-default-address-dialog/choose-default-address-dialog.component';
import {
  DeleteConfirmationDialogComponent,
  IDeleteConfirmationDialogData,
} from '@x/ecommerce-shop/app/core/auth/components/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { SetDefaultAddressDialogComponent } from '@x/ecommerce-shop/app/core/auth/components/set-default-address-dialog/set-default-address-dialog.component';
import {
  IShopAddressInput,
  IShopAuthUser,
  IShopUserAddress,
  IShopUserSubscriber,
} from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

export interface IDefaultAddressDialogData {
  user?: IShopAuthUser | null;
  defaultCountry?: string | null;
  subscribers: IShopUserSubscriber[];
  userAddresses?: IShopUserAddress[];
}

export interface ICreateDefaultAddressResponse {
  newAddressInput?: IShopAddressInput;
  existingAddressId?: number;
}

export type TSetDefaultAddressResponse = number[] | undefined;

@Injectable({
  providedIn: 'root',
})
export class UserAddressDialogService {
  readonly dialog = inject(MatDialog);

  chooseDefaultAddressDialog$(
    data: IDefaultAddressDialogData,
  ): Observable<ICreateDefaultAddressResponse | undefined> {
    return this.dialog
      .open(ChooseDefaultAddressDialogComponent, {
        data,
        disableClose: true,
      })
      .afterClosed();
  }

  setDefaultAddressDialog$(
    data: IDefaultAddressDialogData,
  ): Observable<TSetDefaultAddressResponse> {
    return this.dialog
      .open(SetDefaultAddressDialogComponent, {
        data,
        disableClose: true,
      })
      .afterClosed();
  }

  deleteConfirmationDialog$(title: string, subtitle?: string): Observable<boolean | undefined> {
    const data: IDeleteConfirmationDialogData = { title, subtitle };
    return this.dialog
      .open(DeleteConfirmationDialogComponent, {
        data,
        disableClose: true,
      })
      .afterClosed();
  }
}
